import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '@projeccions-pdc/react-icon';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import { getLocalizedName } from '../../helpers';
import { withStyles } from '@material-ui/core/styles';
import AppContext from '../../AppContext';
import { ImageIcon, ContentIcon, CollectionIcon, MeetingsIcon, VideoIcon, FileIcon } from '../Search/Search';

const styles = theme => ({
    chip: {
        margin: theme.spacing(1),
        zIndex: 9999,
    },
});

let resultTypes = {
    content: ContentIcon,
    col: CollectionIcon,
    mtg: MeetingsIcon,
    image: ImageIcon,
    video: VideoIcon,
    file: FileIcon,
};

class NotificationAttachment extends Component {
    handleItemClick = (evt) => {
        if (this.props.onItemClick) {
            this.props.onItemClick(this.props.resource, evt);
        }
    }

    handleDelete = (evt) => {
        evt.stopPropagation();
        if (this.props.onDelete) {
            this.props.onDelete(this.props.resource);
        }
    }

    render() {
        let language = new AppContext().getLanguage();
        let icon = '';
        if (this.props.resource.resourceType === 'file') {
            icon = resultTypes[this.props.resource.resourceSubtype];
        } else if (
            this.props.resource.resourceType === 'content' &&
            (this.props.resource.resourceSubtype === 'col' ||
                this.props.resource.resourceSubtype === 'mtg')
        ) {
            icon = resultTypes[this.props.resource.resourceSubtype];
        } else {
            icon = resultTypes[this.props.resource.resourceType];
        }
        let names = this.props.resource.names ? this.props.resource.names : this.props.resource.title;

        return (
            <Chip
                data-id={this.props.resource.resourceId}
                data-type="message-attachment"
                avatar={<Avatar><Icon name={icon} /></Avatar>}
                label={<div dangerouslySetInnerHTML={{ __html: getLocalizedName(language, names) }} />}
                onClick={this.props.onItemClick ? this.handleItemClick : undefined}
                onDelete={this.props.onDelete ? this.handleDelete : undefined}
                className={this.props.classes.chip}
            />
        );
    }
}
NotificationAttachment.propTypes = {
    resource: PropTypes.object.isRequired,
    onItemClick: PropTypes.func,
    onDelete: PropTypes.func,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NotificationAttachment);